import type React from 'react';
import { useState } from 'react';
import { useAuth } from '@shadeables/supabase';
import { Button } from '@shadeables/ui';
import { ChangePasswordDialog } from '../../components/modals';
import styles from './SettingsUser.module.css';

const SettingsUser: React.FC = () => {
  const { user } = useAuth();
  const [email, setEmail] = useState(user?.email || '');
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);

  const hasPasswordAuth = user?.identities?.some(
    (identity) => identity.provider === 'email'
  );

  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Updating email', { email });
  };

  const handlePasswordChange = (
    currentPassword: string,
    newPassword: string
  ) => {
    console.log('Changing password', { currentPassword, newPassword });
    setIsPasswordDialogOpen(false);
  };

  if (!hasPasswordAuth) {
    return (
      <div className={styles.settingsUser}>
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Account Information</h3>
          <div className={styles.infoCard}>
            <p className={styles.infoText}>
              You signed in with{' '}
              {user?.identities?.[0]?.provider || 'a third-party provider'}.
            </p>
            <p className={styles.infoText}>
              Email and password changes are not available for accounts that use
              external authentication.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.settingsUser}>
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Email Address</h3>
        <form onSubmit={handleEmailSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.label}>
              Email
            </label>
            <div className={styles.inputGroup}>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={styles.input}
              />
              <Button size="sm">Update Email</Button>
            </div>
          </div>
        </form>
      </div>

      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>Password</h3>
        <div className={styles.passwordSection}>
          <p className={styles.description}>
            Change your password to keep your account secure.
          </p>
          <Button variant="ghost" onClick={() => setIsPasswordDialogOpen(true)}>
            Change Password
          </Button>
        </div>
      </div>

      <ChangePasswordDialog
        isOpen={isPasswordDialogOpen}
        onClose={() => setIsPasswordDialogOpen(false)}
        onSubmit={handlePasswordChange}
      />
    </div>
  );
};

export default SettingsUser;
